// extracted by mini-css-extract-plugin
export default {"container":"styles_container__d4aqT","content":"styles_content__5EJDG","storiesImg":"styles_storiesImg__Tui0d"};